'use client';

import { ComponentType, SVGProps } from 'react';

import { Box, BoxProps, Typography } from '@mui/material';
import cx from 'clsx';

import colors from '@/styles/themes/colors';
import { useTooltipFollow } from '@/utils/hooks/useTooltipFollow';

import styles from './PartnerLogo.module.scss';

interface PartnerLogoProps extends Omit<BoxProps, 'children'> {
  ColoredLogo: ComponentType<{ props?: SVGProps<SVGSVGElement>; size?: string | number }>;
  NeutralLogo: ComponentType<{ props?: SVGProps<SVGSVGElement>; size?: string | number }>;
  size?: string | number;
  tooltipText: string;
}

const PartnerLogo = ({ ColoredLogo, NeutralLogo, size = 64, tooltipText, className, ...rest }: PartnerLogoProps) => {
  const { ref, tooltipRef, isHovered, onMouseMove, onMouseEnter, onMouseLeave } = useTooltipFollow({
    lag: 0.05,
    offset: { x: -45, y: -45 },
  });

  return (
    <Box
      ref={ref}
      className={cx(styles.container, className)}
      onMouseMove={onMouseMove}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      {...rest}
    >
      <Box className={styles.neutral}>
        <NeutralLogo size={size} />
      </Box>
      <Box className={styles.colored}>
        <ColoredLogo size={size} />
      </Box>
      {tooltipText && (
        <Box ref={tooltipRef} className={cx(styles.tooltip, { [styles.visible]: isHovered })}>
          <Typography variant="body2" color={colors.black}>
            {tooltipText}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PartnerLogo;
